import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ActionsTypesResponse } from "subModule/src/services/Notifications/interface";
import { RootState } from "app/store";

const initialState: ActionsTypesResponse = {
    actions: {},
    types: {},
};
const actionSlice = createSlice({
    name: 'actions',
    initialState,
    reducers: {
      setActionTypes: (state, action: PayloadAction<ActionsTypesResponse>) => {
        state.actions = action.payload.actions;
        state.types = action.payload.types;
      },
    },
});

export const { setActionTypes } = actionSlice.actions;
export default actionSlice.reducer;

export const actionTypesInfo = (state: RootState) => state.actions;